import React from 'react';
import { FileText, Eye, Loader2, AlertCircle, FileWarning } from 'lucide-react';

import { useReports } from './hook/useReports';
import {
  //   ReportWrapper,
  //   ReportContainer,
  HeaderSection,
  SectionTitle,
  SectionDescription,
  ActionButtons,
  DashboardButton,
  Section,
  SectionLabel,
  ReportsGrid,
  ReportCard,
  ReportIconWrapper,
  ReportInfo,
  ReportName,
  ReportMeta,
  ViewButton,
  LoadingState,
  EmptyState,
  GlobalError,
} from './Reports.styles';

const formatReportName = (name) =>
  name
    ? name
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase())
    : 'Report';

const Reports = ({ listId, onDashboard }) => {
  const { reportsQuery, reports, handleViewReport, viewReportMutation } = useReports(listId);

  return (
    <>
      <HeaderSection>
        <div>
          <SectionTitle>Reports</SectionTitle>
          <SectionDescription>
            View and download generated reports for this application
          </SectionDescription>
        </div>
        <ActionButtons>
          <DashboardButton type="button" onClick={onDashboard}>
            Dashboard
          </DashboardButton>
        </ActionButtons>
      </HeaderSection>

      {reportsQuery.isError && (
        <GlobalError>
          <AlertCircle size={16} />
          {reportsQuery.error?.message || 'Failed to load reports.'}
        </GlobalError>
      )}

      <Section>
        <SectionLabel>Reports</SectionLabel>

        {reportsQuery.isLoading && (
          <LoadingState>
            <Loader2 size={22} className="spin" />
            <span>Loading reports…</span>
          </LoadingState>
        )}

        {!reportsQuery.isLoading && !reportsQuery.isError && reports.length === 0 && (
          <EmptyState>
            <FileWarning size={36} strokeWidth={1.2} />
            <p style={{ margin: 0 }}>No reports available yet.</p>
          </EmptyState>
        )}

        {!reportsQuery.isLoading && reports.length > 0 && (
          <ReportsGrid>
            {reports.map((report) => {
              const isViewing =
                viewReportMutation.isPending && viewReportMutation.variables === report._id;

              return (
                <ReportCard key={report._id}>
                  <ReportIconWrapper>
                    <FileText />
                  </ReportIconWrapper>
                  <ReportInfo>
                    <ReportName>{formatReportName(report.name)}</ReportName>
                    <ReportMeta>{report.name}</ReportMeta>
                  </ReportInfo>
                  <ViewButton
                    type="button"
                    onClick={() => handleViewReport(report._id)}
                    disabled={isViewing}
                    aria-label={`View ${formatReportName(report.name)}`}
                  >
                    {isViewing ? <Loader2 size={16} className="spin" /> : <Eye />}
                  </ViewButton>
                </ReportCard>
              );
            })}
          </ReportsGrid>
        )}
      </Section>
    </>
  );
};

export default Reports;
